'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var textfield = require('@andes/textfield');
var MaskedInput = require('react-text-mask');
var context = require('@andes/context');
var warning = require('@andes/common/build/utils/warning');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var MaskedInput__default = /*#__PURE__*/_interopDefaultLegacy(MaskedInput);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
const _excluded$1 = ["innerRef"],
  _excluded2 = ["multiline", "render"];
const ComponentMaskedInput = MaskedInput__default["default"].default === undefined ? MaskedInput__default["default"] : MaskedInput__default["default"].default;
ComponentMaskedInput.displayName = 'MaskedInput';
class MaskTextField extends React__default["default"].PureComponent {
  constructor(props) {
    super(props);
    this.renderMask = this.renderMask.bind(this);
  }
  setReference(reference, innerRef, field) {
    const input = field === null || field === void 0 ? void 0 : field.querySelector('input');
    reference(input);
    if (typeof innerRef === 'function') return innerRef(field);
    if (innerRef) innerRef.current = field;
  }
  renderMask(reference, props) {
    const {
        innerRef
      } = props,
      rest = _objectWithoutProperties__default["default"](props, _excluded$1);
    return /*#__PURE__*/React__default["default"].createElement(textfield.TextField, _extends__default["default"]({
      multiline: false,
      ref: this.setReference.bind(this, reference, innerRef)
    }, rest));
  }
  render() {
    const _this$props = this.props,
      rest = _objectWithoutProperties__default["default"](_this$props, _excluded2);
    return /*#__PURE__*/React__default["default"].createElement(ComponentMaskedInput, _extends__default["default"]({
      render: this.renderMask
    }, rest));
  }
}
MaskTextField.defaultProps = _objectSpread__default["default"](_objectSpread__default["default"]({}, MaskedInput__default["default"].defaultProps), {}, {
  type: 'text'
});
var MaskTextField$1 = MaskTextField;
const WARNING_COMPONENT$1 = '<MaskTextField> component will be deprecated in a future major version, please use `Textfield` with `useMask` hook instead.';
const MaskTextFieldContainer = /*#__PURE__*/function () {
  const MaskTextFieldContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
    const componentId = context.useId(props.id);
    React.useEffect(() => {
      warning__default["default"](false, WARNING_COMPONENT$1);
    }, []);
    return /*#__PURE__*/React__default["default"].createElement(MaskTextField$1, _extends__default["default"]({}, props, {
      innerRef: ref,
      id: componentId
    }));
  });
  MaskTextFieldContainer.displayName = 'MaskTextFieldContainer';
  return MaskTextFieldContainer;
}();
var MaskTextFieldContainer$1 = MaskTextFieldContainer;
const _excluded = ["type"];
const MaskNumericField = /*#__PURE__*/function () {
  const MaskNumericField = _ref => {
    let rest = _objectWithoutProperties__default["default"](_ref, _excluded);
    return /*#__PURE__*/React__default["default"].createElement(MaskTextField$1, _extends__default["default"]({
      type: "tel"
    }, rest));
  };
  MaskNumericField.defaultProps = {
    ...MaskTextField$1.defaultProps
  };
  return MaskNumericField;
}();
var MaskNumericField$1 = MaskNumericField;
const WARNING_COMPONENT = '<MaskNumericField> component will be deprecated in a future major version, please use `Textfield` with `useMask` hook';
const MaskNumericFieldContainer = /*#__PURE__*/function () {
  const MaskNumericFieldContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
    const componentId = context.useId(props.id);
    React.useEffect(() => {
      warning__default["default"](false, WARNING_COMPONENT);
    }, []);
    return /*#__PURE__*/React__default["default"].createElement(MaskNumericField$1, _extends__default["default"]({}, props, {
      innerRef: ref,
      id: componentId
    }));
  });
  MaskNumericFieldContainer.displayName = 'MaskNumericFieldContainer';
  return MaskNumericFieldContainer;
}();
var MaskNumericFieldContainer$1 = MaskNumericFieldContainer;
exports.MaskNumericField = MaskNumericFieldContainer$1;
exports["default"] = MaskTextFieldContainer$1;
